import { MapContainer, WMSTileLayer, GeoJSON } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import React, { useEffect } from "react";
import states from '../shapefiles/states.json'
import L from 'leaflet';
import '../css/map.css'
import GeotiffLayer from './GeoTiffLayer.js';



export default function Map1(props) {


    const tiffUrl = require(`../img/Page_1/${props.path}/spi3/spi3_${props.dates}_01_00.tif`);


    const color = (val) => {
        // if (val[0] === 0) {
        //     return
        // }
        // else if (val[0] === 1) {
        //     return '#FFAA00'
        // }
        // else if (val[0] > -1.0 && val[0] <= -0.50) {
        //     return '#FFFF00'
        // }
        // else if (val[0] > -1.5 && val[0] <= -1.0) {
        //     return '#FCD37F'
        // }
        // else if (val[0] > -2.0 && val[0] <= -1.5) {
        //     return '#FFAA00'
        // }
        // else if (val[0] > -3.0 && val[0] <= -2.0) {
        //     return '#E60000'
        // }

        // else if (val[0] !== -3.4028234663852886e+38) {
        //     return '#730000'
        // }

        if (val[0] === NaN) {
            return 'transparent'
        }
        else if (val[0] > -0.50) {
            return '#BDDA57'
        }
        else if (val[0] > -1.0 && val[0] <= -0.50) {
            return '#FFFF00'
        }
        else if (val[0] > -1.5 && val[0] <= -1.0) {
            return '#FCD37F'
        }
        else if (val[0] > -2.0 && val[0] <= -1.5) {
            return '#FFAA00'
        }
        else if (val[0] > -3.0 && val[0] <= -2.0) {
            return '#E60000'
        }
        else if (val[0] <= -3.0) {
            return '#730000'
        }
        else {
            return
        }



    }
    // console.log(val)
    // if (val[0] > -0.50) {
    //     return '#FFFFFF'
    // }
    // else if (val[0] > -1.0 && val[0] <= -0.50) {
    //     return '#FFFF00'
    // }
    // else if (val[0] > -1.5 && val[0] <= -1.0) {
    //     return '#FCD37F'
    // }
    // else if (val[0] > -2.0 && val[0] <= -1.5) {
    //     return '#FFAA00'
    // }
    // else if (val[0] > -3.0 && val[0] <= -2.0) {
    //     return '#E60000'
    // }

    // else if (val[0] !== -3.4028234663852886e+38) {
    //     return '#730000'
    // }
    // else if (val[0] <= -3.0) {
    //     return '#9c9c9c'
    // }


    // }
    const options = {
        pixelValuesToColorFn: (values) =>
            color(values),
        resolution: 64,
        opacity: 1
    };




    const position = [14.716, -14.467];







    useEffect(() => {
        if (!props.map) return;

        const customControler = L.Control.extend({
            options: {
                position: "topleft",
            },

            onAdd: function () {
                const btn = L.DomUtil.create("button");
                btn.title = "Level Button";
                btn.textContent = "↑";
                btn.className = "customButton";


                btn.onclick = function (e) {
                    window.location.reload(false);
                    // var southWest = new L.LatLng(12.2372838, -17.7862419),
                    //     northEast = new L.LatLng(16.6919712, -11.3458996),
                    //     bounds = new L.LatLngBounds(southWest, northEast);
                    // console.log("BUtton clicked", fet);
                    // console.log("BUtton clicked lay", lay);
                    // console.log("BUtton clicked e", e);


                    // // for (i = 0; i < 14; i++) {
                    // if (fet.properties.ADM1 && fet.properties.ADM2 && fet.properties.ADM3) {
                    //     geojsonRef.current.addData(states);
                    //     map.fitBounds(bounds);
                    //     // window.location.reload(true);    
                    // }
                    // else if (!fet.properties.ADM1 && fet.properties.ADM2 && fet.properties.ADM3) {
                    //     console.log("level click",fet.properties.ADM2)
                    //     setFeatureId(fet.properties.ADM2);
                    //     const LevelnewDistricts = AllLocalAdmin.features.filter((local) => {
                    //         return local.properties.ADM2 === featureId;
                    //     });
                    //     console.log(LevelnewDistricts,"level");
                    //     geojsonRef.current.addData(LevelnewDistricts);
                    //     // map.fitBounds(lay.getBounds());
                    // }
                    // }
                };

                return btn;
            },
        });

        props.map.addControl(new customControler());
    }, [props.map]);

    let TileUrl = "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}";
    // let Layer = "OSM-Overlay-WMS";

    return (
        <>

            {/* <button className="mt-0 ml-3" id="refresh" onClick={RefreshHandler}> <FontAwesomeIcon className="h-8 w-8" icon={faArrowUp} /></button> */}

            <MapContainer
                center={position}
                scrollWheelZoom={false}
                zoom={7}
                // maxZoom={10}
                minZoom={7}
                style={{ background: 'white' }}
                ref={props.setmap}
            >
                <WMSTileLayer
                    // layers={Layer}
                    url={TileUrl}

                />
                <GeotiffLayer url={tiffUrl} options={options} />
                {props.map && (<GeoJSON
                    ref={props.refe}
                    data={states}
                    onEachFeature={props.handleEachFeature}
                    style={{ fillColor: 'transparent', color: 'black', weight: 2 }}
                />

                )}
            </MapContainer>
        </>
    );
}